import { alpha, FormLabel, styled, Theme } from "@mui/material";
import { CSSObjectWithLabel } from "react-select";

export const customReactSelectStyles = (theme: Theme) => ({
  control: (provided: CSSObjectWithLabel, state: any) => ({
    ...provided,
    width: "275px",
    fontWeight: 400,
    border: "1px solid",
    "border-color": state.isFocused
      ? theme.palette.primary.main
      : theme.palette.mode === "dark"
      ? `${theme.palette.neutral.main}DD`
      : `${theme.palette.neutral.main}5A`,

    backgroundColor: theme.palette.background.default,
    color: theme.palette.neutral.main,
    boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.primary.main}` : "none",
    "&:hover": {
      "border-color": state.isFocused ? theme.palette.primary.main : theme.palette.neutral.main,
    },

    ".search-icon": {
      marginLeft: "12px",
    },

    // minHeight: 34
    // height: 34,
    fontSize: "14px",
  }),
  menu: (provided: CSSObjectWithLabel) => ({
    ...provided,
    zIndex: 5,
    backgroundColor: theme.palette.background.default,
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    color: theme.palette.text.primary,
  }),

  placeholder: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color:
      theme.palette.mode === "dark"
        ? `${theme.palette.neutral.main}BB`
        : `${theme.palette.neutral.main}5A`,
  }),

  option: (provided: CSSObjectWithLabel, state: { isSelected: boolean; isFocused: boolean }) => ({
    ...provided,
    backgroundColor:
      state.isSelected || state.isFocused ? `${theme.palette.primary.main}1A` : "transparent",
    color: state.isSelected ? theme.palette.primary.main : theme.palette.text.primary,
    cursor: "pointer",
    "&:active": {
      backgroundColor: `${theme.palette.primary.main}1A`, //  when the option is clicked
    },
  }),
  multiValue: (provided: CSSObjectWithLabel) => ({
    ...provided,
    flex: "0 0 auto",
    margin: "2px",
    lineHeight: "16px",
    backgroundColor: alpha(theme.palette.text.primary, 0.1),
  }),
  multiValueLabel: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: theme.palette.neutral.main,
  }),
  singleValue: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: theme.palette.neutral.main,
  }),

  clearIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color:
      theme.palette.mode === "dark"
        ? `${theme.palette.neutral.main}DD`
        : `${theme.palette.neutral.main}5A`,
    "&:hover": {
      color: theme.palette.text.primary,
    },
  }),
  dropdownIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color:
      theme.palette.mode === "dark"
        ? `${theme.palette.neutral.main}DD`
        : `${theme.palette.neutral.main}5A`,
    "&:hover": {
      color: theme.palette.text.primary,
    },
  }),
  container: (provided: CSSObjectWithLabel) => ({
    ...provided,
    "& .select__value-container::-webkit-scrollbar": {
      height: "2px",
    },
    "& .select__value-container::-webkit-scrollbar-track": {
      background:
        theme.palette.mode === "light"
          ? theme.palette.customLightGrey.light
          : theme.palette.gray.contrastText,
    },
    "& .select__value-container::-webkit-scrollbar-thumb": {
      borderRadius: "1px",
    },
  }),

  groupHeading: (provided: CSSObjectWithLabel) => ({
    ...provided,
    fontSize: "12px",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: 36,
    overflowX: "auto",
    overflowY: "hidden",
    flexWrap: "nowrap",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background:
        theme.palette.mode === "light"
          ? theme.palette.customLightGrey.light
          : theme.palette.gray.contrastText,
      marginLeft: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      paddingLeft: "30px",
      marginLeft: "30px",
      borderRadius: "1px",
    },
    "& > div": {
      flex: "0 0 auto",
    },
    "& > div[class*='-Input']": {
      position: "relative",
      transform: "none",
    },
  }),
});

export const StyledLabel = styled(FormLabel)<{
  currentDirection: "rtl" | "ltr";
  isDisabled: boolean;
  isFocused: boolean;
}>(({ theme, currentDirection:_currentDirection, isDisabled, isFocused }) => ({
  position: "absolute",
  // [currentDirection === "rtl" ? "right" : "left"]: "12px",
  left : 12,
  top: "-8px",
  fontSize: "12px",
  background: isDisabled
    ? "transparent"
    : `linear-gradient(to bottom, transparent 50%, ${theme.palette.background.default} 50%)`,
  padding: "0 4px",
  height: "14px",
  transition: "all 0.2s ease-in-out",
  zIndex: 1,
  fontWeight: 600,
  color: isFocused
    ? theme.palette.primary.main
    : isDisabled
    ? theme.palette.text.disabled
    : theme.palette.text.primary,
  borderRadius: "5px",
  display: "flex",
  alignItems: "center",
}));
